import Resource from 'rest-resource'

import { apiClient } from '@/util/api/client.js'

// A beta-program request - one record per form submission. No trailing
// slash: rest-resource builds detail paths as `endpoint + '/' + id`.
export class BetaApplicationResource extends Resource {
    static endpoint = '/v1/beta/applications'
    static client = apiClient

    static async submit(attributes) {
        const response = await this.client.post(this.endpoint, attributes)
        return response.data
    }
}
